<template>
  <div>
    <v-menu offset-y v-model="show" :allow-overflow="true">
      <template v-slot:activator="{ on }">
        <v-text-field
          color="primary"
          v-model="value"
          v-on="on"
          :label="$i18n.t(label)"
          :loading="n_loading"
          :clearable="clearable"
          :rules="rules"
          autocomplete="nope"
          :dense="dense"
          >Dropdown</v-text-field
        >
      </template>
      <v-list elevation="0" v-if="nameMasters && nameMasters.length > 0">
        <v-list-item
          v-for="(name, index) in nameMasters"
          :key="index"
          @click="select(name)"
        >
          <v-list-item-title>{{ name.name }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list elevation="0">
        <v-btn small text color="info" @click="nameMasterCreateDialog = true">
          <v-icon>mdi-plus</v-icon>
          {{ $i18n.t("Add New Name") }}
        </v-btn>
      </v-list>
    </v-menu>
    <z-name-master-create
      @select="select"
      :showDialog="nameMasterCreateDialog"
      :type="type"
      :addNewLabel="addNewLabel"
    ></z-name-master-create>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "NameMasterAutoFill",
  props: {
    value: {
      default: null,
    },
    label: {
      default: "Name Master",
    },
    addNewLabel: {
      default: "Add New Name",
    },
    clearable: {
      default: false,
    },
    dense: {
      default: null,
    },
    type: {
      default: null,
    },
    rules: {
      default: () => [],
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class NameMasterAutoFill extends (Vue, Themeable) {
  nameMaster = "";
  selectedValue = null;
  nameMasters = [];
  nameMasterCreateDialog = false;
  n_loading = false;
  show = false;

  async fetchNameMasters(type) {
    await corpService.populateNameMasters(type);
    this.nameMasters = corpService.nameMasters[type];
  }

  async mounted() {
    this.fetchNameMasters(this.type);
    this.n_loading = false;
  }
  @Watch("value")
  conso(val) {
    this.nameMasterCreateDialog = false;
    if (val) {
      this.selectedValue = val;
    } else {
      this.selectedValue = null;
    }
  }

  select(nameMaster) {
    this.nameMasterCreateDialog = false;
    this.nameMaster = nameMaster;
    if (nameMaster) this.selectedValue = nameMaster.name;
    else this.selectedValue = null;
    this.fetchNameMasters(this.type);
  }

  clear() {
    this.selectedValue = null;
    this.nameMaster = "";
    this.$emit("input", null);
  }

  // @Watch("value")
  // onValueChange(val) {
  //   this.selectedValue = val;
  // }

  @Watch("type", { immediate: true })
  async onTypeChange(val) {
    await this.fetchNameMasters(val);
  }

  @Watch("selectedValue")
  async onFilterChange(val) {
    this.selectedValue = val;
    this.value = val;
    this.$emit("input", this.selectedValue);
  }

  @Watch("nameMasters")
  onMastersChange(val) {
    if (!val || val.length == 0) this.show = false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
